import type { BulkPersonActionInput, ManagedPerson } from "#shared/managePeopleContract.ts";

export function isSelfIncluded(person: Pick<ManagedPerson, "id">, currentMemberId: string | undefined): boolean {
    return currentMemberId !== undefined && person.id.toLowerCase() === currentMemberId.toLowerCase();
}

export function excludeSelfFromBulkInput(input: BulkPersonActionInput, currentMemberId: string | undefined): BulkPersonActionInput {
    if (!currentMemberId) {
        return input;
    }

    if ("personIds" in input) {
        return { personIds: input.personIds.filter(id => id.toLowerCase() !== currentMemberId.toLowerCase()) };
    }

    return input.excludedIds.some(id => id.toLowerCase() === currentMemberId.toLowerCase()) ? input : { ...input, excludedIds: [...input.excludedIds, currentMemberId] };
}
